import RichTextHtmlElement from 'shared/components/FormKitBuilderContainer/FormElements/RichTextHtmlElement.vue';
import { plugin, defaultConfig } from "@formkit/vue";
import { iconCheckmark, iconRadio, iconSearch } from "@coloplast/design-system/dist/exports/icons";
import { createProPlugin, mask, autocomplete, dropdown, taglist } from '@formkit/pro'
import scrollToErrors /*, { FormKitHierarchicalSelect } */ from 'multisite/formkit.config';
import maskLengthValidation from 'shared/components/FormKitBuilderContainer/formkitMask.config'
import "@coloplast/design-system/dist/components/formkit/formkit.css";
import { generateClasses } from "@formkit/themes";
import { FORMKIT_ENTERPRISE_KEY } from 'constants/formkit';

/**
 * Initializes the FormKit schema.
 * @param {Object} app - The application object.
 * @param {Object} [options] - The options for initializing the FormKit schema.
 * @param {boolean} [options.useBarcode] - Whether to use the barcode module.
 * @returns {Promise<void>} - A promise that resolves when the FormKit schema is initialized.
 */
export async function initFormKitSchema(app, options) {

	let barcode;

	if (options?.useBarcode) {
		// This module is quite large, so we only import it if we need it
		const module = await import('@formkit/barcode');
		barcode = module.barcode;
	}

	const proPlugin = createProPlugin(FORMKIT_ENTERPRISE_KEY, {
		mask,
		autocomplete,
		dropdown,
		taglist
	});

	app.component('RichTextHtmlElementCmp', RichTextHtmlElement);
	app.use(
		plugin,
		defaultConfig({
			/* You'll need to register the design system icons you'd like to use in the FormKit inputs */
			inputs: {
				barcode,
			},
			icons: {
				check: iconCheckmark,
				search: iconSearch,
				checkboxDecorator: iconCheckmark,
				radioDecorator: iconRadio,
			},
			plugins: [proPlugin, scrollToErrors, maskLengthValidation],
			config: {
				classes: generateClasses({
					/* We reset button and submit styles, and instead point them to the design system button classes */
					button: {
						input: "$reset ds-button ds-button--primary",
					},
					submit: {
						input: "$reset ds-button ds-button--primary",
					},
				}),
			}
		}),
	);
}
